import { render, staticRenderFns } from "./Inscripciones.vue?vue&type=template&id=459999d2&scoped=true"
import script from "./Inscripciones.vue?vue&type=script&lang=js"
export * from "./Inscripciones.vue?vue&type=script&lang=js"
import style0 from "./Inscripciones.vue?vue&type=style&index=0&id=459999d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459999d2",
  null
  
)

export default component.exports